// extracted by mini-css-extract-plugin
module.exports = {"root":"_4e2917","carousel":"_7f28c4","topicsContainer":"_a7779b","rightShadow":"_529356","leftShadow":"_28a13b"};